import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Auth.module.css';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { useAuth } from '../../store/AuthContext';
import { useToast } from '../../store/ToastContext';
import { validators, validateForm } from '../../utils/validation';
import { MailIcon, CheckCircleIcon } from '../../components/Icons';

function ForgotPassword() {
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();
  const toast = useToast();
  
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validation = validateForm({ email }, {
      email: [validators.required, validators.email],
    });

    if (!validation.isValid) {
      setErrors(validation.errors);
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (error) {
      toast.error(error.message || 'Failed to send reset OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleProceedToReset = () => {
    navigate('/reset-password', { state: { email } });
  };

  if (sent) {
    return (
      <div className={styles.formContainer}>
        <div className={styles.successContainer}>
          <div className={styles.successIcon}>
            <CheckCircleIcon size={48} />
          </div>
          <h2 className={styles.formTitle}>Check your email</h2>
          <p className={styles.formSubtitle}>
            We've sent a 6-digit OTP to<br />
            <strong>{email}</strong>
          </p>
          <Button onClick={handleProceedToReset}>
            Enter OTP
          </Button>
          <Button variant="secondary" onClick={() => setSent(false)} style={{ marginTop: '12px' }}>
            Try different email
          </Button>
        </div>
        <p className={styles.formFooter}>
          <Link to="/login" className={styles.link}>
            Back to login
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div className={styles.formContainer}>
      <div className={styles.formHeader}>
        <h2 className={styles.formTitle}>Forgot password?</h2>
        <p className={styles.formSubtitle}>
          Enter your email and we'll send you an OTP to reset your password
        </p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          label="Email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setErrors({});
          }}
          error={errors.email}
          leftIcon={<MailIcon />}
          autoComplete="email"
        />

        <Button type="submit" fullWidth loading={loading}>
          Send Reset OTP
        </Button>
      </form>

      <p className={styles.formFooter}>
        Remember your password?{' '}
        <Link to="/login" className={styles.link}>
          Sign in
        </Link>
      </p>
    </div>
  );
}

export default ForgotPassword;
